module.exports = __webpack_public_path__ + "static/media/Project-japan.a26846ad.svg";